<template>
  <div>
    <drop-down :multiLevel="true">
      <md-button class="md-button md-info dropdown-toggle md-wd">
        <span class="item-icon">
          <i class="fas fa-layer-group"></i>
        </span>
        <span :title="selectedTitle">{{titleLength(selectedTitle)}}</span>
      </md-button>

      <div class="dropdown-menu">
        <sl-vue-tree
          v-model="nodes"
          ref="applianceMenu"
          :allowMultiselect="false"
          @select="onNodeSelect"
          @drop="onNodeDragAndDropped"
          @toggle="onNodeToggled"
          @nodedblclick="onNodeDblClick"
        >
          <template slot="title" slot-scope="{ node }">
            <span v-if="node.isLeaf">
              <span v-if="node.data.phase == 'L1'" class="dot dot_L1" title="L1"></span>
              <span v-if="node.data.phase == 'L2'" class="dot dot_L2" title="L2"></span>
              <span v-if="node.data.phase == 'L3'" class="dot dot_L3" title="L3"></span>
            </span>

            <span class="item-icon">
              <i class="fab fa-medapps" v-if="node.isLeaf"></i>
              <i class="fas fa-layer-group" v-if="!node.isLeaf"></i>
            </span>

            <span v-if="node.data.isEdited">
              <md-field style="display: inline;">
                <md-input
                  style="display: inline; width:100px;"
                  :value="node.title"
                  v-focus
                  v-on:keyup.enter="submitEdited(node, $event.target.value)"
                ></md-input>
              </md-field>
            </span>

            <span
              v-if="!node.data.isEdited"
              @mouseenter="onNodeMouseEnter(node, $event)"
              @mouseleave="onNodeMouseLeave(node, $event)"
            >
              <span :title="node.title">{{ titleLength(node.title) }}</span>

              <span v-if="!node.isLeaf">{{countOfChildren(node)}}</span>

              <md-button
                v-if="!node.isLeaf && node.data.showButton"
                class="md-button md-just-icon md-simple"
                @click="deleteParentNode()"
              >
                <md-icon class="md-size-1x">close</md-icon>
              </md-button>

              <md-button
                v-if="node.isLeaf && node.data.showButton"
                class="md-button md-just-icon md-simple"
                @click="modalOpen(node, $event)"
              >
                <md-icon class="md-size-1x">more_vert</md-icon>
              </md-button>
            </span>
          </template>

          <template slot="toggle" slot-scope="{ node }">
            <span v-if="!node.isLeaf">
              <i v-if="node.isExpanded" class="fa fa-chevron-down"></i>
              <i v-if="!node.isExpanded" class="fa fa-chevron-right"></i>
            </span>
          </template>

          <template slot="draginfo">{{selectedTitle}}</template>
        </sl-vue-tree>

        <div class="hierarchy-new-object">
          <md-field>
            <label>{{$lang.keys.add_new_group}}</label>
            <md-input v-on:keyup.enter="createParentNode()" v-model="newGroup"></md-input>
          </md-field>
        </div>
      </div>
    </drop-down>

    <modal v-if="showModal" @close="modalClose()">
      <template slot="header">
        <h4 class="modal-title">{{modalData.name}}</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="modalClose()"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field>
              <label>{{$lang.general.name}}</label>
              <md-input
                v-model="modalData.name"
                pattern=".{3,}"
                maxlength="30"
                @keyup.enter="modalSave()"
                type="text"
                ref="editName"
              ></md-input>
            </md-field>
          </div>
        </div>
      </template>

      <template slot="footer">
        <md-button class="md-primary" @click="modalSave()">{{$lang.keys.save}}</md-button>
        <md-button class="md-danger" @click="modalDelete()">{{$lang.keys.delete}}</md-button>
        <md-button class="md-simple" @click="modalClose()">{{$lang.keys.close}}</md-button>
      </template>
    </modal>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import { getUserToken, getSelectedDeviceToken } from "@/storage/memoryStorage";
import SlVueTree from "sl-vue-tree";
import { Modal } from "@/components";
import axios from "axios";
import Swal from "sweetalert2";
import snackBar from "@/components/SnackBar";

const focus = {
  inserted(el) {
    el.focus();
  }
};

export default {
  name: "appliance-menu",
  directives: { focus },
  components: {
    "sl-vue-tree": SlVueTree,
    Modal,
    "snack-bar": snackBar
  },
  data() {
    return {
      modalData: {},
      showModal: false,
      selectedTitle: this.$lang.keys.no_group,
      newGroup: "",
      nodes: []
    };
  },
  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },
  watch: {
    selectedDevice: function(newDevice, oldDevice) {
      if (newDevice.mac !== oldDevice.mac) {
        this.loadApplianceMenu();
      }
    }
  },

  created() {
    this.loadApplianceMenu();
  },

  methods: {
    titleLength(title) {
      if (title.length > 20) {
        return title.slice(0, 20) + "...";
      }
      return title;
    },

    modalSave() {
      if (this.modalData.name.length >= 3) {
        axios({
          method: "PUT",
          url: this.$ENDPOINTS.API_R + "/nilm/appliances",
          data: {
            token: getSelectedDeviceToken(this.selectedDevice.mac),
            ID_appliance: this.modalData.ID,
            name: this.modalData.name
          },
          withCredentials: true
        })
          .then(response => {
            if (response.data.status === "OK") {
              const applianceTree = this.$refs.applianceMenu;

              let nodeData = Object.assign({}, this.modalData.node.data);
              nodeData.isEdited = false;
              nodeData.showButton = false;

              applianceTree.updateNode(this.modalData.node.path, {
                title: this.modalData.name,
                data: nodeData
              });

              const selectedAndUpdated = applianceTree.getSelected()[0];
              if (!selectedAndUpdated.isLeaf) {
                this.selectedTitle = this.modalData.name;
                this.$emit("on-selected", selectedAndUpdated);
              }
            }
          })
          .catch(error => {
            if (error.response.data.status == "FAIL") {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          });

        this.modalClose();
      }
    },

    modalOpen(node, event) {
      this.modalData.ID = node.data.ID_appliance;
      this.modalData.name = node.title;
      this.modalData.node = node;

      this.showModal = true;

      this.$nextTick(() => {
        this.$refs.editName.$el.focus();
      });
    },

    modalClose() {
      this.showModal = false;
    },

    modalDelete() {
      this.modalClose();

      Swal.queue([
        {
          title: this.$lang.general.are_you_sure,
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$lang.keys.yes,
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: () => {
            return axios({
              method: "DELETE",
              url: this.$ENDPOINTS.API_R + "/nilm/appliances",
              data: {
                user_token: getUserToken(),
                device_token: getSelectedDeviceToken(this.selectedDevice.mac),
                ID: this.modalData.ID,
                remove: "APPLIANCE"
              },
              withCredentials: true
            })
              .then(response => {
                const applianceTree = this.$refs.applianceMenu;
                const removePaths = [];
                removePaths.push(this.modalData.node.path);

                applianceTree.remove(removePaths);
                this.selectDefaultGroup();
                this.saveApplianceMenu();
              })
              .then(() => {
                Swal.insertQueueStep({
                  title: this.$lang.messages.success,
                  text: this.$lang.messages.success_removed_device,
                  type: "success",
                  confirmButtonClass: "md-button md-success",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false,
                  timer: 2000
                });
              })
              .catch(error => {
                Swal.insertQueueStep({
                  title: this.$lang.messages.error,
                  text: this.$lang.messages.api_communication_error,
                  type: "error",
                  confirmButtonClass: "md-button md-warning",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false
                });
              });
          }
        }
      ]);
    },

    saveApplianceMenu() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/facility/appliances-hierarchy",
        data: {
          user_token: getUserToken(),
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          menu: JSON.stringify(this.nodes)
        },
        withCredentials: true
      }).catch(error => {
        this.$refs.snackbar.notify(this.$lang.messages.api_communication_error);
      });
    },

    loadApplianceMenu() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/facility/appliances-hierarchy",
        data: {
          user_token: getUserToken(),
          device_token: getSelectedDeviceToken(this.selectedDevice.mac)
        },
        withCredentials: true
      })
        .then(response => {
          this.nodes = response.data.data;
          this.selectDefaultGroup();
        })
        .catch(error => {
          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    selectDefaultGroup() {
      const nodesLength = this.nodes.length;
      for (let i = 0; i < nodesLength; i++) {
        if (!this.nodes[i].isLeaf) {
          if (this.nodes[i].data.type == "main") {
            this.nodes[i].title = this.$lang.general.unknown;
            this.selectedTitle = this.nodes[i].title;

            this.$emit("on-selected", this.nodes[i]);
            return;
          } else {
            this.selectedTitle = this.nodes[i].title;

            this.$emit("on-selected", this.nodes[i]);
            return;
          }
        }
      }
    },

    createParentNode() {
      this.nodes.push({
        title: this.newGroup,
        isExpanded: false,
        children: [],
        data: {}
      });
      this.saveApplianceMenu();
      this.newGroup = "";
    },

    deleteParentNode() {
      const applianceTree = this.$refs.applianceMenu;
      const path = applianceTree.getSelected().map(node => node.path);
      const nodeChildren = applianceTree
        .getSelected()
        .map(node => node.children);

      if (nodeChildren[0].length == 0) {
        applianceTree.remove(path);
        this.saveApplianceMenu();
      } else {
        this.$refs.snackbar.notify(this.$lang.messages.object_not_empty);
      }
    },

    countOfChildren(node) {
      let counter = 0;

      node.children.forEach(element => {
        if (element.isLeaf) {
          counter++;
        }
      });

      if (counter > 0) {
        return " (" + counter + ")";
      } else {
        return "";
      }
    },

    submitEdited(nodeSelected, newNodeTitle) {
      if (nodeSelected.isLeaf) {
        axios({
          method: "PUT",
          url: this.$ENDPOINTS.API_R + "/nilm/appliances",
          data: {
            token: getSelectedDeviceToken(this.selectedDevice.mac),
            ID_appliance: nodeSelected.data.ID_appliance,
            name: newNodeTitle
          },
          withCredentials: true
        })
          .then(response => {
            if (response.data.status === "OK") {
              this.updateNodeTitle(nodeSelected, newNodeTitle);
            }
          })
          .catch(error => {
            if (error.response.data.status == "FAIL") {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          });
      } else {
        this.updateNodeTitle(nodeSelected, newNodeTitle);
      }
    },

    updateNodeTitle(nodeSelected, newNodeTitle) {
      const applianceTree = this.$refs.applianceMenu;

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.isEdited = false;
      nodeData.showButton = false;

      applianceTree.updateNode(nodeSelected.path, {
        title: newNodeTitle,
        data: nodeData
      });

      const selectedAndUpdated = applianceTree.getSelected()[0];
      if (!selectedAndUpdated.isLeaf) {
        this.selectedTitle = newNodeTitle;
        this.$emit("on-selected", selectedAndUpdated);
      }

      this.saveApplianceMenu();
    },

    onNodeSelect(nodes, event) {
      if (!this.showModal) {
        const applianceTree = this.$refs.applianceMenu;
        event.stopPropagation();

        applianceTree.traverse((node, nodeModel, path) => {
          let nodeData = Object.assign({}, node.data);
          nodeData.isEdited = false;

          applianceTree.updateNode(node.path, {
            data: nodeData
          });
        });

        const selectedNode = nodes[0];
        if (!selectedNode.isLeaf) {
          this.selectedTitle = selectedNode.title;
          this.$emit("on-selected", selectedNode);
        }
      }
    },

    onNodeDragAndDropped(nodes, position, event) {
      this.selectDefaultGroup();
      this.saveApplianceMenu();
    },

    onNodeToggled(node, event) {
      this.saveApplianceMenu();
    },

    onNodeMouseEnter(nodeSelected, event) {
      if (nodeSelected.data.type != "main") {
        const applianceTree = this.$refs.applianceMenu;

        let nodeData = Object.assign({}, nodeSelected.data);
        nodeData.showButton = true;

        applianceTree.updateNode(nodeSelected.path, {
          data: nodeData
        });
      }
    },

    onNodeMouseLeave(nodeSelected, event) {
      const applianceTree = this.$refs.applianceMenu;

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.showButton = false;

      applianceTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    },

    onNodeDblClick(nodeSelected, event) {
      const applianceTree = this.$refs.applianceMenu;
      event.stopPropagation();

      applianceTree.traverse((node, nodeModel, path) => {
        let nodeData = Object.assign({}, node.data);
        nodeData.isEdited = false;
        applianceTree.updateNode(node.path, { data: nodeData });
      });

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.isEdited = true;

      applianceTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    },

    getDataForGroup(parent) {
      let result = [];
      let idx = 0;

      if (parent.children) {
        for (idx = 0; idx < parent.children.length; idx++) {
          if (parent.children[idx].isLeaf) {
            result.push({
              group: parent.children[idx].title,
              appliances: [
                {
                  ID: parent.children[idx].data.ID_appliance
                }
              ]
            });
          } else {
            result.push({
              group: parent.children[idx].title,
              appliances: []
            });

            const groupLength = result.length;
            this.createGroupData(parent.children[idx]).forEach(group => {
              result[groupLength - 1].appliances.push({
                ID: group.ID,
                title: group.title
              });
            });
          }
        }
      }
      return result;
    },

    createGroupData(parent) {
      let result = [];
      let idx = 0;

      if (parent.children) {
        for (idx = 0; idx < parent.children.length; idx++) {
          if (parent.children[idx].isLeaf) {
            result.push({
              ID: parent.children[idx].data.ID_appliance,
              title: parent.children[idx].title
            });
          } else {
            this.createGroupData(parent.children[idx]).forEach(appliance => {
              result.push(appliance);
            });
          }
        }
      }
      return result;
    }
  }
};
</script>


<style lang="scss" scoped>
i {
  width: 33px;
  height: 33px;
  line-height: 33px;
  text-align: center;
}

.md-list {
  width: 320px;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid rgba(#000, 0.12);
}

.hierarchy-new-object {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.md-button {
  height: 40px;
}

.md-card-actions .md-layout-item {
  padding: 0;
}

.md-chips.md-field {
  padding: 0;
  margin: 0;
}

.items-inline {
  display: inline;
}

.md-button.md-just-icon {
  height: 35px;
}

@media only screen and (min-width: 500px) {
  .dropdown-menu {
    width: 400px;
  }
}

@media only screen and (min-width: 550px) {
  .dropdown-menu {
    width: 450px;
  }
}

@media only screen and (max-width: 450px) {
  .dropdown-menu {
    left: -55px;
  }
}

.dropdown-menu {
  min-width: 350px;
}

.status-icon {
  width: 10px;
  height: auto;
  /*   margin-right: 12px;  */
}
</style>


<style lang="scss">
@import "./src/assets/scss/md/_variables";

.modal-container {
  color: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  );
}

.md-chips.md-field .md-input {
  max-width: 90px;
}

.sl-vue-tree.sl-vue-tree-root {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  height: auto;
}

.sl-vue-tree {
  position: relative;
  cursor: default;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.sl-vue-tree.sl-vue-tree-root {
  background-color: #ffffff;
  color: #414d5c;
  border-radius: 3px;
}

.sl-vue-tree-root > .sl-vue-tree-nodes-list {
  overflow: hidden;
  position: relative;
  padding-bottom: 4px;
}

.sl-vue-tree-selected > .sl-vue-tree-node-item {
  background-color: #ffffff;
  color: #414d5c;
}
.sl-vue-tree-node-item:hover,
.sl-vue-tree-node-item.sl-vue-tree-cursor-hover {
  background-color: $green-300;
  color: #ffffff;
  cursor: pointer;
}

.sl-vue-tree-node-item {
  position: relative;
  display: flex;
  flex-direction: row;

  padding-left: 10px;
  padding-right: 10px;
  line-height: 35px;
  border: 1px solid transparent;
}

.sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
  border: 1px solid rgba(255, 255, 255, 0.5);
}

@media only screen and (max-width: 500px) {
  .sl-vue-tree-gap {
    width: 10px;
    min-height: 1px;
  }
}

@media only screen and (min-width: 500px) {
  .sl-vue-tree-gap {
    width: 25px;
    min-height: 1px;
  }
}

.sl-vue-tree-toggle {
  display: inline-block;
  text-align: left;
  width: 20px;
}

.sl-vue-tree-sidebar {
  margin-left: auto;
}

.sl-vue-tree-cursor {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.5);
  height: 1px;
  width: 100%;
}

.sl-vue-tree-drag-info {
  position: absolute;
  background-color: $green-400;
  opacity: 0.85;
  margin-left: 20px;
  padding: 5px 10px;
}

.item-icon {
  display: inline-block;
  text-align: left;
  /* width: 20px;
  padding-right: 7px; */
}

.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}

.dot_L1 {
  background-color: #00bcd4;
}

.dot_L2 {
  background-color: #f44336;
}

.dot_L3 {
  background-color: #4caf50;
}
</style>

